/*
  NDI Testimonials — case-study modal helpers. Ported from the old theme.
  Open/close are wired via inline onclick (add/remove `.open` on #csModal); this
  adds backdrop-click-to-close and lowers header/badge z-index while the modal is open.
  Vanilla JS, deferred.
*/
(function () {
  function init() {
    var modal = document.getElementById('csModal');
    if (!modal) return;
    var header = document.querySelector('.ndi-header, .header-container');

    modal.addEventListener('click', function (e) {
      if (e.target === this) this.classList.remove('open');
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') modal.classList.remove('open');
    });

    new MutationObserver(function () {
      var isOpen = modal.classList.contains('open');
      // Lock background scroll. The document scrolls on <html>, so the CSS
      // `body:has(...)` rule alone doesn't hold — lock the root element here.
      document.documentElement.style.overflow = isOpen ? 'hidden' : '';
      if (header) header.style.zIndex = isOpen ? '0' : '';
      var saBadge = document.querySelector('.shopperlink, .sa-widget-container, [class*="sa-seal"]');
      if (saBadge) saBadge.style.zIndex = isOpen ? '0' : '';
    }).observe(modal, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
